import {create} from 'zustand';

const LOCAL_KEY = 'app_config_v1';

function loadConfig() {
    try {
        const raw = localStorage.getItem(LOCAL_KEY);
        if (raw) return JSON.parse(raw);
    } catch (_) {}
    return null;
}

function saveConfig(cfg) {
    try {
        localStorage.setItem(LOCAL_KEY, JSON.stringify(cfg));
    } catch (_) {}
}

const defaultApiBase = 'https://fizmataa.ru:5000/api';
const defaultStaticBase = 'https://fizmataa.ru:5000';

const initial = loadConfig() || {
    apiBaseUrl: defaultApiBase,
    staticBaseUrl: defaultStaticBase,
};

const useConfigStore = create((set, get) => ({
    apiBaseUrl: initial.apiBaseUrl,
    staticBaseUrl: initial.staticBaseUrl,

    setApiBaseUrl(url) {
        const next = {...get(), apiBaseUrl: url};
        saveConfig({
            apiBaseUrl: next.apiBaseUrl,
            staticBaseUrl: next.staticBaseUrl,
        });
        set({apiBaseUrl: url});
    },

    setStaticBaseUrl(url) {
        const next = {...get(), staticBaseUrl: url};
        saveConfig({
            apiBaseUrl: next.apiBaseUrl,
            staticBaseUrl: next.staticBaseUrl,
        });
        set({staticBaseUrl: url});
    },
}));

export default useConfigStore;

export function getApiBaseUrl() {
    try {
        const raw = localStorage.getItem(LOCAL_KEY);
        if (raw) return JSON.parse(raw).apiBaseUrl || defaultApiBase;
    } catch (_) {}
    return defaultApiBase;
}

export function getStaticBaseUrl() {
    try {
        const raw = localStorage.getItem(LOCAL_KEY);
        if (raw) return JSON.parse(raw).staticBaseUrl || defaultStaticBase;
    } catch (_) {}
    return defaultStaticBase;
}
